<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-6 form-group pr-xl-4">
        <label for="memberNumber">Member Number</label>
        <input type="text" class="form-control" id="memberNumber" required>
        <div class="invalid-tooltip">Please include your Member Number.</div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6 form-group pr-xl-4">
        <label for="password">Password</label>
        <input type="password" class="form-control" id="password" maxlength="30" required v-model="password.password">
        <div class="invalid-tooltip">Please include your Password.</div>
      </div>
      <div class="col-12 col-sm-6 form-group pl-xl-4">
        <label for="confirmPassword">Confirm Password</label>
        <input type="password" class="form-control" id="confirmPassword" maxlength="30" required v-model="password.confirmPassword">
        <div class="invalid-tooltip">Please ensure your password matches.</div>
      </div>
    </div>
  </div>
</template>

<script>
/* UNUSED FILE CURRENTLY */
export default {
  data() {
    return {
      password: {
        password: '',
        confirmPassword: ''
      }
    }
  },
  watch: {
    password: {
      handler(password) {
        this.$emit('input', password)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Account/RegisterExisting.vue